// Links do site. Preencha as URLs reais das redes; as que ficarem vazias abrem "#".
export const SOCIALS = [
  { id: "instagram", label: "Instagram", url: "" },
  { id: "facebook", label: "Facebook", url: "" },
  { id: "youtube", label: "YouTube", url: "" },
  { id: "discord", label: "Discord", url: "https://discord.gg/WYqVwHgnqme" },
];

// ── Endereços: no seu PC (localhost) usam as portas de desenvolvimento; no servidor real (pkxidle.com) tudo vem do próprio domínio ──
//   site + API  -> https://pkxidle.com   (a API fica em /api, o admin em tempo real em /ws)
//   jogo        -> https://jogo.pkxidle.com
// Para forçar outro endereço na hora de gerar o site: REACT_APP_API_URL, REACT_APP_GAME_ORIGIN
const _host = typeof window !== "undefined" ? window.location.hostname : "localhost";
const _proto = typeof window !== "undefined" ? window.location.protocol : "http:";
export const IS_LOCAL = /^(localhost|127.0.0.1|[::1])$/.test(_host);
export const BACKEND_ORIGIN = process.env.REACT_APP_API_URL || (IS_LOCAL ? "http://localhost:8000" : (typeof window !== "undefined" ? window.location.origin : ""));
export const API_BASE = (process.env.REACT_APP_API_URL || (IS_LOCAL ? "http://127.0.0.1:8000" : (typeof window !== "undefined" ? window.location.origin : ""))) + "/api";
export const WS_ADMIN_URL = BACKEND_ORIGIN.replace(/^http/, "ws") + "/ws/admin";

// Servidor do jogo (cliente web)
export const GAME_ORIGIN = process.env.REACT_APP_GAME_ORIGIN || (IS_LOCAL ? "http://localhost:8080" : `${_proto}//jogo.${_host.replace(/^www./, "")}`);
// Onde procurar o servidor do jogo em chamadas que antes tentavam vários endereços
export const GAME_BASES = IS_LOCAL ? ["http://localhost:8080", "http://127.0.0.1:8080", "http://localhost:8000", "http://127.0.0.1:8000", ""] : [GAME_ORIGIN, BACKEND_ORIGIN];
